module.exports = __webpack_public_path__ + "static/img/givvy.ea3a381d.png";